import uploadDocumentsReducer from "./uploadDocumentsSlice";

export default uploadDocumentsReducer;
